<template>
  <div>
    <div class="footer" v-if="!userAgent">
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502012218">
        <img src="@/assets/images/police.png" alt />
      </a>
      <div>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502012218">
          <span>公安备案号 31011502012218</span>
        </a>
        <a href="https://beian.miit.gov.cn/#/Integrated/index">
          <span>沪ICP备17005246号-1</span>
        </a>
      </div>
    </div>
    <div class="footer1" v-else>
     <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502012218">
        <img src="@/assets/images/police.png" alt />
      </a>
      <div>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502012218">
          <span>公安备案号 31011502012218</span>
        </a>
        <a href="https://beian.miit.gov.cn/#/Integrated/index">
          <span>沪ICP备17005246号-1</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "my-footer",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scope>
.footer {
  position: relative;
  width: 100%;
  height: 4rem;
  background: #2f2f2f;
  text-align: center;
  bottom: 0;
  line-height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  span {
    color: #fff;
    font-size: 18px;
    padding: 0 10px 0;
    vertical-align: middle;
  }
  img {
    vertical-align: middle;
    display: inline-block;
  }
}
.footer1 {
  position: relative;
  width: 100%;
  height: 3rem;
  background: #2f2f2f;
  text-align: center;
  bottom: 0;
  line-height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  div {
    padding-left: 0.2rem;
    span {
      color: #fff;
      font-size: 11px;
      padding-left: 0.1rem;
      vertical-align: middle;
    }
  }
}
a {
  text-decoration: none;
}
</style>